import React from "react";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import '../general/General.css';
import { useNavigate } from "react-router-dom";
import { useCheckAccess } from "../../utils/Utilities";

const ContactAdmin = () => {
  useCheckAccess('ContactAdmin'); // Check if the user is logged in (if no user data, redirect to login)
  const navigate = useNavigate();
  return (
    <>
      <Navbar />
      <Helmet>
        <title>ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள் | Contact Admin</title>
        <link rel="canonical" href="/donation" />
      </Helmet>
      <>
        <div className="general_parent">
          <div className="general_container">
            <div className="general_body">
              <Breadcrumbs /><br />
              <button onClick={() => navigate("/contact/bulk-sms-send")}>Send Bulk SMS</button>
              <button onClick={() => navigate("/contact/bulk-sms-delivery-check")}>Check Delivery Status Bulk SMS</button>
              <button onClick={() => navigate("/contact/bulk-update-mobile-status")}> Bulk Update Mobile Status</button>
              <button onClick={() => navigate("/contact/donation-folloup-sms-send")}> Donation followup SMS Send</button>
              
              <br />
            </div>
          </div>
        </div>
      </>
      <br />
      <Footer />
    </>
  );
};

export default ContactAdmin;
